import AdminUsers from "../../components/admin/admin-users/AdminUsers";
import AdminTemplate from "../../views/AdminTemplate";

const AdminUsersPage = () => {
  return (
    <AdminTemplate>
      <AdminUsers />
    </AdminTemplate>
  );
};

export default AdminUsersPage;
